module.exports = __webpack_public_path__ + "static/images/styles/images/challenges/icon-onslaught.cf0ebd67.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/challenges/icon-onslaught.png
// module id = 3613
// module chunks = 11